import { CustomSection } from "components/MainSectionTemplate/types";
import React from "react";
import { CreditPanel } from "../CreditPanel";

interface Props {
  client: server.dto.Client,
}

export const creditSection = (props: Props): CustomSection => {
  const { client } = props;

  return {
    key: "creditSection",
    type: "custom",
    render: () => <CreditPanel clientId={client.clientId} />,
  }
}